<div class="hamburger-container">
  <button name="main menu" mat-icon-button (click)="clickHamburger()" aria-label="main menu" tabindex="1">
    <span></span>
    <span></span>
    <span></span>
  </button>
  <ng-container [termsPolicy]></ng-container>
</div>
